<template>
  <div>
    <!-- PreciosView -->
  </div>
</template>

<script>
export default {
  name: 'PreciosView'
}
</script>



// WEBPACK FOOTER //
// src/views/web/PreciosView.vue